
function unGroup(resList, obj, key) {
    let tplObj = JSON.parse(JSON.stringify(obj));
    let list = tplObj[key];
    delete tplObj[key];
    resList.push(tplObj)
    if (list) {
        for (let i = 0; i < list.length; ++i) {
            unGroup(resList, list[i], key)
        }
    }
}

export function unGroupList(list, key) {
    var resList = [];
    for (let i = 0; i < list.length; ++i) {
        unGroup(resList, list[i], key)
    }
    return resList;
}
